import React from "react";
import PageNumbers from "./PageNumbers";
import ResultsCounter from "./ResultsCounter";

const TablePagination = ({ pageNumber, onChange, pageSize, totalItems }) => {
  return (
    <footer className="table-pagination">
      <ResultsCounter
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalItems={totalItems}
      />
      <PageNumbers
        activePage={pageNumber}
        onChange={onChange}
        pageSize={pageSize}
        totalItems={totalItems}
      />
    </footer>
  );
};

export default TablePagination;
